export type UnitSystem = 'metric' | 'us'

const storageKey = 'mapapal.unitSystem'
const kilometersToMiles = 0.621371
const metersToFeet = 3.28084

export function readUnitSystem(storage: Pick<Storage, 'getItem'> = localStorage): UnitSystem {
  return storage.getItem(storageKey) === 'us' ? 'us' : 'metric'
}

export function storeUnitSystem(unitSystem: UnitSystem, storage: Pick<Storage, 'setItem'> = localStorage): void {
  storage.setItem(storageKey, unitSystem)
}

function decimal(value: number): string {
  return value.toLocaleString('en-GB', { maximumFractionDigits: 1 })
}

export function formatDistance(kilometers: number, unitSystem: UnitSystem): string {
  return unitSystem === 'us'
    ? `${decimal(kilometers * kilometersToMiles)} mi`
    : `${decimal(kilometers)} km`
}

export function formatSpeed(kilometersPerHour: number, unitSystem: UnitSystem): string {
  return unitSystem === 'us'
    ? `${decimal(kilometersPerHour * kilometersToMiles)} mph`
    : `${decimal(kilometersPerHour)} km/h`
}

export function formatElevation(meters: number, unitSystem: UnitSystem): string {
  return unitSystem === 'us'
    ? `${Math.round(meters * metersToFeet)} ft`
    : `${Math.round(meters)} m`
}
